import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';

export class MonthlyPensionJurisdictionDetail implements Deserializable {
  public id!: string;
  public governingJurisdictionId!: number | null;
  public governingJurisdiction!: GoverningJurisdictionType | null;
  public definedContributionAvailableLockedBalance!: number | null;
  public definedContributionAvailableUnlockedBalance!: number | null;
  public definedContributionLockedAmountToUnlock!: number | null;
  public definedContributionLockedPercentageToUnlock!: number | null;
  public definedContributionLockedInAmount!: number | null;
  public definedContributionUseEntireLockedInBalance!: boolean;
  public definedContributionUnlockedAmount!: number | null;
  public definedContributionUseEntireUnlockedBalance!: boolean;
  public variableBenefitAvailableBalance!: number | null;
  public variableBenefitAmount!: number | null;
  public variableBenefitUseEntireBalance!: boolean;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }
  }
}
